import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FacebookOutlined, GlobalOutlined, WhatsAppOutlined, YoutubeOutlined } from '@ant-design/icons';
import { Carousel, Typography, Card, Row, Col, Input, Spin } from 'antd';
import { BACKEND_URL } from '../Backend';
import axios from 'axios';
import carousel4 from "../img/carousel4.webp";
import carousel3 from "../img/carousel3.webp";
import footerImage from '../img/footer.webp';

const { Title } = Typography;
const { Meta } = Card;
const { Search } = Input;

const CarerasPublico = () => {
  const [carreras, setCarreras] = useState([]);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    // Scroll to top cuando cambie la página
    window.scrollTo(0, 0);
    setCargando(true);

    // Obtiene carreras desde el backend
    Promise.all([
      axios.get(`${BACKEND_URL}/carrerasTSU`),
      axios.get(`${BACKEND_URL}/carrerasING_Y_CDI`),
      axios.get(`${BACKEND_URL}/imgCarreras`)
    ])
    .then(([resTSU, resING_Y_CDI, resImg]) => {
      // Combina ambos arrays
      const todasCarreras = [...resTSU.data, ...resING_Y_CDI.data];
      const imagenes = resImg.data;

      // Asignar imagen a cada carrera si hay match por pk_carrera
      const carrerasConImagen = todasCarreras.map((carrera) => {
        const imagenEncontrada = imagenes.find(
          (img) => img.pk_carrera === carrera.pk_carrera
        );
        return {
          ...carrera,
          img: imagenEncontrada ? imagenEncontrada.img : null,
        };
      });

      setCarreras(carrerasConImagen);
    })
    .catch((error) => {
      console.error('Error al obtener datos:', error);
    })
    .finally(() => {
      setCargando(false);
    });
  }, []);

  return (
    <div style={{ padding: '20px', minHeight: '100vh' }}>
      {/* Carousel */}
      <Carousel autoplay autoplaySpeed={5000} dotPosition="bottom">
        <div>
          <img src={carousel4} alt="Slide 1" style={{ width: '100%', maxHeight: '340px', objectFit: 'cover' }} />
        </div>
        <div>
          <img src={carousel3} alt="Slide 2" style={{ width: '100%', maxHeight: '340px', objectFit: 'cover' }} />
        </div>
        <div>
          <img src={carousel3} alt="Slide 3" style={{ width: '100%', maxHeight: '340px', objectFit: 'cover' }} />
        </div>
        <div>
          <img src={footerImage} alt="Slide 4" style={{ width: '100%', maxHeight: '340px', objectFit: 'cover' }} />
        </div>
      </Carousel>

      {/* Título principal */}
      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <Title level={2}>¡Bienvenidos al repositorio de tesis y memorias!</Title>
        <Title level={4}>Explora los trabajos académicos más destacados de nuestra universidad.</Title>
      </div>

   
      {/* Sección de carreras */}
      <Title level={3} style={{ marginTop: '40px', textAlign: 'center' }}>Carreras:</Title>
      
      <Spin spinning={cargando}>
        <Row gutter={[16, 16]} justify="center">
          {carreras.map((carrera) => (
            <Col key={carrera.pk_carrera} xs={24} sm={12} md={8} lg={6} xl={5}>
              <Link to={`/alumnospublico/${carrera.pk_carrera}`}>
                <Card
                  hoverable
                  style={{
                    borderRadius: '12px',
                    overflow: 'hidden',
                    textAlign: 'center',
                    height: '100%',
                  }}
                  cover={
                    carrera.img ? (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: 'auto',
                          maxHeight: '400px',
                          padding: '10px',
                        }}
                      >
                        <img
                          alt={carrera.nombre}
                          src={`${BACKEND_URL}${carrera.img}`}
                          style={{
                            width: '70%',
                            height: 'auto',
                            maxHeight: '100%',
                            objectFit: 'contain',
                            borderRadius: '8px',
                          }}
                        />
                      </div>
                    ) : (
                      <div style={{ height: '200px', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        Sin imagen
                      </div>
                    )
                  }
                >
                  <Meta title={carrera.nombre} />
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </Spin>

      {/* Footer con imagen */}
      <div style={{ marginTop: '60px' }}>
        <img
          src={footerImage}
          alt="Footer"
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '500px',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </div>

      {/* Información de contacto */}
      <Title style={{ display: 'flex', justifyContent: 'center' }} level={5}>
        UTESC. Camino al Guasimal S/N, al Noroeste de la Ciudad, Colonia Centro, C.P. 82400, Escuinapa, Sinaloa, México. Teléfono (695) 110 5779
      </Title>
      
      <br />
      
    </div>
  );
};

export default CarerasPublico;